import { QuestionBase } from './question-base.model';

export class RadioQuestion extends QuestionBase<boolean> {
   controlType = 'radio';
   options: { key: string, value: string }[] = [];
   default: any;
   disabled: boolean;
   visible: string;
   getterKey: any;
   getterValue: any;

   constructor(options: {} = {}) {
      super(options);
      this.options = options['options'] || [];
      this.default = options['default'];
      this.visible = (options['visible'] == undefined) ? true : options['visible'];
      this.disabled = options['disabled'] || false;
      this.getterKey = options['getterKey'] || null;
      this.getterValue = options['getterValue'] || null;
   }
}